import { pickBy } from 'es-toolkit';

export const pickTruthy = <T extends Record<string, unknown>>(
  obj: T,
): { [K in keyof T]?: NonNullable<T[K]> } => {
  return pickBy(obj, Boolean) as { [K in keyof T]?: NonNullable<T[K]> };
};
